import Box from '@mui/material/Box';
import React, {useEffect, useRef, useState} from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import axios from 'axios';
import {config} from '../../common/config/config';
import {constance} from '../../common/constance/constance';
import {common} from '../../common/common';
import {DateTime, Duration} from 'luxon';
import {isMobile} from 'react-device-detect';
import {User} from '../../interface/user.interface';

interface State {
    title: string,
    time: Date,
    days: string,
    hours: string,
    minutes: string,
    seconds: string,
    presenterName: string,
    department: string,
    user: User,
    dateFormat: string,
    timeFormat: string,
}

let countDownInterval: any;

export default function CultureForumCalendar() {
    console.log(`[CulturalForumCalendar]`);
    const [state, setState] = useState<State>({
        time: new Date(), days: '00', hours: '00', minutes: '00', seconds: '00',
        title: '',
        department: '',
        presenterName: '',
        user: {
            id: '',
            departmentCode: '',
            departmentName: '',
            name: '',
            _id: '',
            admin: false
        }, dateFormat: '', timeFormat: '',
    });
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const makeTime: any = useRef();

    useEffect(() => {
        axios.get(constance.api.getCultureForumCalendar).then(value => {
            console.log(value.data);
            let user: User = value.data.user;
            user.id.trim();
            user.name.trim();
            user.departmentName.trim();
            user.departmentCode.trim();

            function timeReSet() {
                let time = new Date(value.data.data.time);
                let dateFormat = DateTime.fromMillis(time.getTime()).toFormat('yyyy년 MM월 dd일');
                dateFormat += ' ' + common.getWeekDayText(DateTime.fromMillis(time.getTime()).weekday, isMobile);
                let timeFormat = DateTime.fromMillis(time.getTime()).toFormat('HH:mm');
                let diff = DateTime.fromMillis(time.getTime()).diff(DateTime.local());
                let countDown = Duration.fromObject(diff.toObject()).toFormat('ddThh:mm:ss');

                let days = countDown.split('T')[0];
                let hours = countDown.split('T')[1].split(':')[0];
                let minutes = countDown.split('T')[1].split(':')[1];
                let seconds = countDown.split('T')[1].split(':')[2];

                if (days.indexOf("-") > -1) days = '00';
                if (hours.indexOf("-") > -1) hours = '00';
                if (minutes.indexOf("-") > -1) minutes = '00';
                if (seconds.indexOf("-") > -1) seconds = '00';

                setState({
                    ...state,
                    days: days,
                    hours: hours,
                    minutes: minutes,
                    seconds: seconds,
                    title: value.data.data.title,
                    dateFormat: dateFormat,
                    timeFormat: timeFormat,
                    user: user,
                });
            }

            timeReSet();
            countDownInterval = setInterval(() => {
                timeReSet();
            }, 1000);
        }).catch(reason => {
            common.alert('', reason.message, 'error');
        });

        return () => {
            clearInterval(countDownInterval);
        };
    }, []);

    function handleOpenWebex() {
        window.open("https://lgu-sib.webex.com/wbxmjs/joinservice/sites/lgu-sib/meeting/download/860b046ce516675c6cb745c2ab6f47ca", "_blank");
    }

    return (
        <>
            <Box sx={{display: 'flex', justifyContent: 'center'}}>
                <Stack sx={{
                    width: 1,
                    maxWidth: config.maxWidth,
                    display: 'flex', alignItems: 'center',
                    justifyContent: 'center', mt: 4, mb: 2,
                }}>
                    <Typography variant={isMobile ? 'h5' : 'h4'} align={'center'}
                                sx={{color: '#8e8e8e'}}>{'Until The Next Forum'}</Typography>

                    {/* 카운트다운 */}
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: 1,
                        mt: 8,
                        pl: 1,
                        pr: 1
                    }}>
                        <Stack sx={{width: 1 / 4, display: 'flex', justifyContent: 'center', alighItems: 'center'}}>
                            <Typography variant={isMobile ? 'h2' : 'h1'} align={'center'}
                                        sx={{
                                            color: '#8e8e8e',
                                            textShadow: '2px 2px 2px #b1b1b1',
                                            fontWeight: 700,
                                        }}>{state.days}</Typography>
                            <Box sx={{display: 'flex', justifyContent: 'center'}}>
                                <Typography variant={'h6'} sx={{fontWeight: 700}}>{'D'}</Typography>
                                <Typography variant={'h6'} sx={{color: '#8e8e8e'}}>{'ays'}</Typography>
                            </Box>
                        </Stack>

                        <Stack sx={{width: 1 / 4, display: 'flex', justifyContent: 'center', alighItems: 'center'}}>
                            <Typography variant={isMobile ? 'h2' : 'h1'} align={'center'}
                                        sx={{
                                            color: '#8e8e8e',
                                            textShadow: '2px 2px 2px #b1b1b1',
                                            fontWeight: 700,
                                        }}>{state.hours}</Typography>
                            <Box sx={{display: 'flex', justifyContent: 'center'}}>
                                <Typography variant={'h6'} sx={{fontWeight: 700}}>{'H'}</Typography>
                                <Typography variant={'h6'} sx={{color: '#8e8e8e'}}>{'ours'}</Typography>
                            </Box>
                        </Stack>

                        <Stack sx={{width: 1 / 4, display: 'flex', justifyContent: 'center', alighItems: 'center'}}>
                            <Typography variant={isMobile ? 'h2' : 'h1'} align={'center'}
                                        sx={{
                                            color: '#8e8e8e',
                                            textShadow: '2px 2px 2px #b1b1b1',
                                            fontWeight: 700,
                                        }}>{state.minutes}</Typography>
                            <Box sx={{display: 'flex', justifyContent: 'center'}}>
                                <Typography variant={'h6'} sx={{fontWeight: 700}}>{'M'}</Typography>
                                <Typography variant={'h6'} sx={{color: '#8e8e8e'}}>{'inutes'}</Typography>
                            </Box>
                        </Stack>

                        <Stack sx={{width: 1 / 4, display: 'flex', justifyContent: 'center', alighItems: 'center'}}>
                            <Typography variant={isMobile ? 'h2' : 'h1'} align={'center'}
                                        sx={{
                                            color: '#8e8e8e',
                                            textShadow: '2px 2px 2px #b1b1b1',
                                            fontWeight: 700,
                                        }}>{state.seconds}</Typography>
                            <Box sx={{display: 'flex', justifyContent: 'center'}}>
                                <Typography variant={'h6'} sx={{fontWeight: 700}}>{'S'}</Typography>
                                <Typography variant={'h6'} sx={{color: '#8e8e8e'}}>{'econds'}</Typography>
                            </Box>
                        </Stack>
                    </Box>


                    {/* 타이틀 */}
                    <Stack sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: 1,
                        mt: isMobile ? 8 : 16,
                        pl: 2,
                        pr: 2
                    }}>
                        <Typography variant={isMobile ? 'h3' : 'h1'}
                                    sx={{fontWeight: 600, textShadow: '2px 2px 2px #b1b1b1', textAlign: 'center'}}>
                            {state.title}
                        </Typography>
                    </Stack>

                    {/* 시간, 발표자 */}
                    <Stack sx={{
                        display: 'flex', justifyContent: 'center', alignItems: 'center',
                        width: {xs: 1, sm: 1, md: 0.5},
                        maxWidth: 400,
                        mt: 12,
                        pl: 2, pr: 2,
                    }}>
                        <Box sx={{width: 1, display: 'flex', mt: 1}}>
                            <Box sx={{width: 0.3}}>
                                <Typography variant={isMobile ? 'h6' : 'h5'}
                                            sx={{fontWeight: 600}}>{'Date'}</Typography>
                            </Box>
                            <Box sx={{width: 0.7}}>
                                <Typography variant={isMobile ? 'h6' : 'h5'}
                                            sx={{color: '#8e8e8e'}}>{state.dateFormat}</Typography>
                            </Box>
                        </Box>

                        <Box sx={{width: 1, display: 'flex', mt: 1}}>
                            <Box sx={{width: 0.3}}>
                                <Typography variant={isMobile ? 'h6' : 'h5'}
                                            sx={{fontWeight: 600}}>{'Time'}</Typography>
                            </Box>
                            <Box sx={{width: 0.7}}>
                                <Typography variant={isMobile ? 'h6' : 'h5'}
                                            sx={{color: '#8e8e8e'}}>{state.timeFormat}</Typography>
                            </Box>
                        </Box>

                        <Box sx={{width: 1, display: 'flex', mt: 1}}>
                            <Box sx={{width: 0.3}}>
                                <Typography variant={isMobile ? 'h6' : 'h5'}
                                            sx={{fontWeight: 600}}>{'Speaker'}</Typography>
                            </Box>
                            <Box sx={{width: 0.7}}>
                                <Typography variant={isMobile ? 'h6' : 'h5'} sx={{color: '#8e8e8e'}}>
                                    {`${state.user.departmentName} ${state.user.name}`}
                                </Typography>
                            </Box>
                        </Box>
                    </Stack>

                    <Box onClick={handleOpenWebex}
                         sx={{
                             height: isMobile? 90: 120,
                             position: 'absolute',
                             bottom: isMobile? 15: 50,
                             right: isMobile? 15: 50,
                             borderRadius: '50%',
                             cursor: 'pointer',
                             transition: '0.3s ease-in-out',
                             ': hover': {
                                 height: isMobile? 90: 150,
                                 'img': {
                                     opacity: 0.7,
                                     border: '3px solid #b5b2b2'
                                 }
                             }
                         }}>
                        <img src={`/images/webex.png`}
                             style={{height: '100%', border: '1px solid #b5b2b2', borderRadius: '50%'}}/>
                    </Box>

                </Stack>
            </Box>
        </>
    );
}